// extracted by mini-css-extract-plugin
export default {"buttons":"SummaryComponent_buttons__inQeH","modal":"SummaryComponent_modal__SHvl+","head":"SummaryComponent_head__6cEg5"};